export const GET_ALL_EVENTS = {
    INIT: "GET_ALL_EVENTS_INIT",
    SUCCESS: "GET_ALL_EVENTS_SUCCESS",
    ERROR: "GET_ALL_EVENTS_ERROR"
}